/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import ErrorMessage from '../../../../share/ErrorMessage'
import { IndexWidgetsType } from '../../types'
import { InsightCount } from '../../../../../schemas/action/InsightCountSchema'

const IndexWidgetBelowThresholdGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<IndexWidgetsType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const entries = widgetData.data[0].results![0].data.insights![0].dataset
  const values = entries!.flatMap((entry) => entry.set).map((entry) => entry!.value!)

  if ('minCount' in widgetSetting) {
    const isBelowThreshold = values.every((value) => value < (widgetSetting.minCount || 0))

    if (isBelowThreshold) return <ErrorMessage>{t('emptyBecauseLowCount')}</ErrorMessage>
  }

  return children
}

export default IndexWidgetBelowThresholdGuard
